import React, { useState } from 'react';
import Logo from './Logo';

const FAQPage = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqData = [
    {
      id: 1,
      question: "Apa itu PAK MoO?",
      answer: "PAK MoO adalah platform digital yang menyediakan layanan tabungan qurban dan investasi ternak sapi. Kami menghubungkan masyarakat dengan peternak terpercaya untuk memberikan solusi modern dalam berinvestasi dan menabung untuk keperluan qurban."
    },
    {
      id: 2,
      question: "Bagaimana cara kerja tabungan qurban di PAK MoO?",
      answer: "Tabungan qurban PAK MoO memungkinkan Anda menabung secara bertahap untuk membeli hewan qurban. Anda dapat menabung sesuai kemampuan, dan ketika target tercapai, kami akan menyediakan hewan qurban berkualitas dari mitra peternak terpercaya."
    },
    {
      id: 3,
      question: "Apakah investasi ternak di PAK MoO aman?",
      answer: "Ya, investasi ternak di PAK MoO sangat aman. Kami bekerja sama dengan peternak berpengalaman dan tersertifikasi. Setiap investasi dilindungi dengan sistem monitoring yang ketat dan asuransi untuk meminimalkan risiko."
    },
    {
      id: 4,
      question: "Berapa minimal investasi atau tabungan di PAK MoO?",
      answer: "Minimal tabungan qurban adalah Rp 100.000 per bulan, sedangkan minimal investasi ternak adalah Rp 1.000.000. Anda dapat menyesuaikan dengan kemampuan finansial Anda."
    },
    {
      id: 5,
      question: "Bagaimana cara melihat perkembangan investasi saya?",
      answer: "Anda dapat memantau perkembangan investasi melalui dashboard member area. Di sana tersedia laporan real-time tentang kondisi ternak, pertumbuhan, dan estimasi keuntungan yang akan Anda dapatkan."
    },
    {
      id: 6,
      question: "Kapan saya bisa menarik keuntungan investasi?",
      answer: "Keuntungan investasi dapat ditarik sesuai dengan periode yang telah disepakati, biasanya 6-12 bulan tergantung jenis investasi. Anda akan mendapatkan notifikasi ketika periode investasi berakhir."
    },
    {
      id: 7,
      question: "Apakah ada biaya administrasi?",
      answer: "PAK MoO mengenakan biaya administrasi yang sangat minimal, yaitu 2% dari total investasi atau tabungan. Biaya ini sudah termasuk monitoring, asuransi, dan layanan customer support."
    },
    {
      id: 8,
      question: "Bagaimana jika saya ingin membatalkan investasi?",
      answer: "Pembatalan investasi dapat dilakukan dengan pemberitahuan 30 hari sebelumnya. Namun, untuk hasil optimal, kami menyarankan untuk menyelesaikan periode investasi sesuai kontrak yang telah disepakati."
    },
    {
      id: 9,
      question: "Apakah hewan qurban dijamin halal dan berkualitas?",
      answer: "Tentu saja! Semua hewan qurban dari PAK MoO telah tersertifikasi halal dan berkualitas tinggi. Kami bekerja sama dengan peternak yang memiliki sertifikat halal dan mengikuti standar kesehatan hewan yang ketat."
    },
    {
      id: 10,
      question: "Bagaimana cara menghubungi customer service PAK MoO?",
      answer: "Anda dapat menghubungi customer service kami melalui WhatsApp di nomor +62 812-3456-7890, email di support@pakmoo.com, atau melalui fitur konsultasi yang tersedia di aplikasi."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <section id="faq-page" className="min-h-screen bg-gray-50">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white sticky top-0 z-10 shadow-sm">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <button 
                onClick={() => window.history.back()}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <h1 className="text-xl font-bold text-primary">FAQ</h1>
            </div>
            <div className="flex items-center space-x-2">
              <Logo size="small" showText={false} />
              <span className="font-bold text-primary text-sm">PAK MoO</span>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-8 bg-gray-50">
          {/* Hero Section */}
          <section className="px-4 pt-6 pb-4 bg-white">
            <div className="text-center">
              <div className="bg-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fa-solid fa-circle-question text-primary text-3xl"></i>
              </div>
              <h2 className="text-2xl font-bold text-primary mb-2">Frequently Asked Questions</h2>
              <p className="text-gray-600">Temukan jawaban untuk pertanyaan yang sering diajukan tentang layanan PAK MoO</p>
            </div>
          </section>

          {/* FAQ List */}
          <section className="px-4 mt-6">
            <div className="space-y-4">
              {faqData.map((faq) => (
                <div key={faq.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                  <button
                    className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                    onClick={() => toggleFAQ(faq.id)}
                  >
                    <h3 className="font-semibold text-gray-800 pr-4">{faq.question}</h3>
                    <i className={`fa-solid fa-chevron-down text-primary transition-transform ${openFAQ === faq.id ? 'rotate-180' : ''}`}></i>
                  </button>
                  
                  {openFAQ === faq.id && (
                    <div className="px-6 pb-4 border-t border-gray-100">
                      <p className="text-gray-600 leading-relaxed pt-4">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>

          {/* Contact Section */}
          <section className="px-4 mt-8">
            <div className="bg-secondary rounded-2xl p-6 text-white text-center">
              <i className="fa-solid fa-headset text-accent text-3xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Masih Ada Pertanyaan?</h3>
              <p className="text-sm opacity-90 mb-4">Tim customer service kami siap membantu Anda 24/7</p>
              <button 
                className="bg-accent text-primary font-semibold px-6 py-3 rounded-lg hover:bg-accent/90 transition-colors"
                onClick={() => window.open('https://wa.me/6281234567890?text=Halo,%20saya%20memiliki%20pertanyaan%20tentang%20PAK%20MoO', '_blank')}
              >
                <i className="fa-brands fa-whatsapp mr-2"></i>
                Hubungi Kami
              </button>
            </div>
          </section>

          {/* Quick Links */}
          <section className="px-4 mt-6">
            <div className="bg-white rounded-2xl p-6">
              <h3 className="text-lg font-bold text-primary mb-4">Link Berguna</h3>
              <div className="space-y-3">
                <button 
                  className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition-colors text-left"
                  onClick={() => window.location.href = '/katalog'}
                >
                  <div className="flex items-center space-x-3">
                    <i className="fa-solid fa-cow text-primary"></i>
                    <span className="font-medium text-gray-800">Lihat Katalog Sapi</span>
                  </div>
                  <i className="fa-solid fa-chevron-right text-gray-400"></i>
                </button>
                
                <button 
                  className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition-colors text-left"
                  onClick={() => window.location.href = '/'}
                >
                  <div className="flex items-center space-x-3">
                    <i className="fa-solid fa-home text-primary"></i>
                    <span className="font-medium text-gray-800">Kembali ke Beranda</span>
                  </div>
                  <i className="fa-solid fa-chevron-right text-gray-400"></i>
                </button>
              </div>
            </div>
          </section>
        </main>
      </div>
    </section>
  );
};

export default FAQPage;
